<template>
  <div
    :id="props.project.id"
  	v-if="!props.isprintView" 
    ref="projectEl"
    class="sidebar-group"
    :class="{ open: props.isopen }"
    :style="{ height: `${rowHeight}px` }"
    @click="emit('update', props.project.id)"
  >
    <div class="flex items-center justify-between w-full px-2">
      <div class="flex items-center gap-2">
        <ChevronRight :size="16" v-if="!props.isopen"/>
        <ChevronDown  :size="16" v-if="props.isopen"/>
        {{ props.project.name }}
      </div>

      <div v-show="props.isopen" class="flex items-center">
        <Button variant="ghost" size="icon" @click.stop="activeFilterMenu = !activeFilterMenu">
          <Filter :size="16" />
        </Button>
        <Button variant="ghost" size="icon" @click.stop="activePrintMenu = !activePrintMenu">
          <Ellipsis :size="16"/>
        </Button>
      </div>
    </div>

    <ResourceFilterCallout 
      :id="`filter-${props.project.id}`"
      :target="projectEl"
      :show="activeFilterMenu"
      :resourceFilter="props.resourceFilter"
      :users="props.users"
      @close="activeFilterMenu = false"
      @updateFilter="(data) => emit('updateResourceFilter', props.project.id, data)"
    />

    <PrintCallout 
      :id="`print-${props.project.id}`"
      :target="projectEl"
      :show="activePrintMenu"
      :project="props.project"
	    @close="activePrintMenu = false"
      @print-view="handlePrintAction"
    />
  </div>

  <div v-if="props.isopen">

    <div v-if="props.isprintView"  :style="{ height: `${rowHeight}px` }" class="content">
      Team
    </div>

    <div v-for="u in filteredUsers" :key="u.id" :style="{ height: `${rowHeight}px` }" class="content">
      {{ u.firstname }} {{ props.isprintView ? u.lastname : u.short }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { rowHeight, hasBookings, applyResoureFilter } from "./planner.js"
import ResourceFilterCallout from './ResourceFilterCallout.vue'
import PrintCallout from './PrintCallout.vue'
import { Button } from "@/components/ui/button"
import { ChevronRight, ChevronDown, Ellipsis, Filter } from "lucide-vue-next"

const props = defineProps(['project', 'users', 'bookings', 'isopen', 'resourceFilter', 'isprintView'])
const emit = defineEmits(['update', 'updateResourceFilter', 'printView'])

const projectEl = ref(null)
const activeFilterMenu = ref(false)
const activePrintMenu = ref(false)

const filteredUsers = computed(() => 
  props.users.filter(u => applyResoureFilter(props.resourceFilter, props.project, u))
)



// Watch for selection logic as before
watch(() => props.resourceFilter.selection, (newVal) => {
  if (newVal === 0) {
    props.resourceFilter.hasBookings = hasBookings(props.project, props.users, props.bookings)
  } else if (newVal === 2) {
    props.resourceFilter.hasBookings = props.users.map(u => u.id)
  }
})

function handlePrintAction(start: string, end: string) {
    emit('printView', props.project, start, end);
}
</script>

<style scoped>

.sidebar-group {
  border: 1px solid #ccc;
  overflow: hidden;
  transition: height 0.3s ease;
  display: flex;
}

.sidebar-group.spacer {
  background-color: rgb(250, 250, 250);
}

.content {
  padding: 8px;
  background: #fff;
}

.toggle {
  font-size: 0.8em;
}

</style>
